webpackJsonp([192279678295350],{

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _prismicDom = __webpack_require__(10);
	
	var _rebass = __webpack_require__(4);
	
	var _theme = __webpack_require__(13);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _components = __webpack_require__(7);
	
	var _moment = __webpack_require__(23);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var translatedLabels = {
	  "en-us": {
	    Active: "Active",
	    Approved: "Approved",
	    Canceled: "Canceled",
	    Archived: "Archived",
	    Proposed: "Proposed"
	  },
	  "es-mx": {
	    Active: "Activo",
	    Approved: "Aprobado",
	    Canceled: "Cancelado",
	    Archived: "Archivado",
	    Proposed: "Propuesto"
	  },
	  "ar-eg": {
	    Active: "جاري",
	    Approved: "وافق",
	    Canceled: "ألغيت",
	    Archived: "أرشفة",
	    Proposed: "مقترح"
	  }
	};
	
	var determineColor = function determineColor(region) {
	  var color = "violet";
	  if (region === "update" || region === "institution" || region === null || region === undefined) {
	    color = "ash";
	  }
	  if (region === "middle-east-and-north-africa" || region === "oriente-medio-y-norte-de-africa" || region === "الشرق-الاوسط-وشمات-افريقيا") {
	    color = "orange";
	  }
	  if (region === "africa" || region === "africa1" || region === "افريقيا") {
	    color = "green";
	  }
	  if (region === "latin-america" || region === "america-latina-y-el-caribe" || region === "امريكا-اللاتينية") {
	    color = "blue";
	  }
	  if (region === "asia" || region === "asia1" || region === "اسيا") {
	    color = "pink";
	  }
	  if (region === "europe--central-asia" || region === "europa-y-asia-central" || region === "اوروبا-واسيا-الوسطى") {
	    color = "yellow";
	  }
	  return color;
	};
	
	var linkResolver = function linkResolver(doc) {
	  return "/" + doc.type;
	};
	
	var Project = function (_React$Component) {
	  _inherits(Project, _React$Component);
	
	  function Project() {
	    _classCallCheck(this, Project);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Project.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.data.page.alternate_languages) {
	      this.context.setAltLanguages(this.props.data.page.alternate_languages);
	    } else {
	      this.context.setAltLanguages(undefined);
	    }
	    document.body.style.background = _theme2.default.colors[determineColor(this.props.data.page.data.region.uid)];
	  };
	
	  Project.prototype.render = function render() {
	    var json = undefined;
	    if (this.props.data.page.raw) {
	      json = JSON.parse(this.props.data.page.raw);
	    }
	    return _react2.default.createElement(
	      "div",
	      {
	        style: this.props.transition ? this.props.transition.style : { opacity: 0 }
	      },
	      _react2.default.createElement(_components.Head, {
	        source: {
	          meta_title: [{
	            text: json.data.title !== undefined ? json.data.title[0] ? json.data.title[0].text + " | Bank Information Center" : "" : ""
	          }],
	          meta_description: [{
	            text: json.data.excerpt !== undefined ? json.data.excerpt[0] ? json.data.excerpt[0].text : "" : ""
	          }],
	          social_sharing_image: {
	            url: json.data.header_image !== undefined ? json.data.header_image.url : ""
	          }
	        }
	      }),
	      _react2.default.createElement(
	        _components.Main,
	        null,
	        _react2.default.createElement(
	          _components.PageHeader,
	          {
	            title: json.data.title !== undefined ? json.data.title[0] ? json.data.title[0].text : "" : "",
	            color: json.data.region.uid,
	            image: json.data.header_image.url ? [json.data.header_image.url, json.data.header_image.half.url] : ""
	          },
	          json.data.excerpt[0] && _react2.default.createElement(_components.Text, { children: json.data.excerpt[0].text })
	        ),
	        _react2.default.createElement(
	          _components.PageSection,
	          null,
	          _react2.default.createElement(
	            _components.PageSidebar,
	            { mobileTop: "true" },
	            _react2.default.createElement(
	              _rebass.Box,
	              { mt: [-48, null, null, 0], mx: [0, -32, -48, 0] },
	              _react2.default.createElement(
	                _rebass.Box,
	                { mx: [-24, 0], px: 4, py: 5, bg: "grey.1" },
	                json.data.location && _react2.default.createElement(
	                  _rebass.Box,
	                  { mb: 3 },
	                  _react2.default.createElement(_components.H4, {
	                    children: json.lang === "en-us" ? "Location" : json.lang === "es-mx" ? "Ubicación" : "الموقع",
	                    mb: 1
	                  }),
	                  _react2.default.createElement(
	                    _components.Text,
	                    null,
	                    json.data.location
	                  )
	                ),
	                json.data.cost && _react2.default.createElement(
	                  _rebass.Box,
	                  { mb: 3 },
	                  _react2.default.createElement(_components.H4, {
	                    children: json.lang === "en-us" ? "Total Cost" : json.lang === "es-mx" ? "Costo total" : "التكلفة الإجمالية",
	                    mb: 1
	                  }),
	                  _react2.default.createElement(
	                    _components.Text,
	                    null,
	                    json.data.cost
	                  )
	                ),
	                json.data.funding_source && _react2.default.createElement(
	                  _rebass.Box,
	                  { mb: 3 },
	                  _react2.default.createElement(_components.H4, {
	                    children: json.lang === "en-us" ? "Funding" : json.lang === "es-mx" ? "Financiación" : "التمويل",
	                    mb: 1
	                  }),
	                  _react2.default.createElement(
	                    _components.Text,
	                    null,
	                    json.data.funding_source
	                  )
	                ),
	                json.data.status && _react2.default.createElement(
	                  _rebass.Box,
	                  null,
	                  _react2.default.createElement(_components.H4, {
	                    children: json.lang === "en-us" ? "Status" : json.lang === "es-mx" ? "Estado" : "الحالة",
	                    mb: 1
	                  }),
	                  _react2.default.createElement(
	                    _components.Text,
	                    null,
	                    translatedLabels[json.lang][json.data.status]
	                  )
	                )
	              ),
	              this.props.data.author && _react2.default.createElement(_components.UpdateMeta, {
	                updateText: json.lang === "en-us" ? "Last update" : json.lang === "es-mx" ? "Última actualización" : "اخر تحديث",
	                attributionText: json.lang === "en-us" ? "Monitored by" : json.lang === "es-mx" ? "Supervisado por" : "مراقب من قبل",
	                staffName: this.props.data.author.data.title[0] ? this.props.data.author.data.title[0].text : "",
	                staffImage: this.props.data.author.data.header_image.url ? this.props.data.author.data.header_image.quarter.url : "",
	                secondaryStaffName: this.props.data.secondary_author && this.props.data.secondary_author.data.title[0] ? this.props.data.secondary_author.data.title[0].text : "",
	                secondaryStaffImage: this.props.data.secondary_author && this.props.data.secondary_author.data.header_image.url ? this.props.data.secondary_author.data.header_image.quarter.url : ""
	                // publishDate={
	                //   json.data.publish_date
	                //     ? moment(json.data.publish_date).format("MMMM Do, YYYY")
	                //     : ""
	                // }
	                // updateDate={
	                //   json.last_publication_date
	                //     ? moment(json.last_publication_date).format(
	                //         "MMMM Do, YYYY"
	                //       )
	                //     : ""
	                // }
	                , to: this.props.data.author.lang + "/team/" + this.props.data.author.uid,
	                secondaryTo: this.props.data.secondary_author ? this.props.data.author.lang + "/team/" + this.props.data.secondary_author.uid : ""
	              }),
	              _react2.default.createElement(
	                _rebass.Box,
	                { mt: 1, mx: [-4, 0] },
	                this.props.data.region && _react2.default.createElement(_components.TinyTile, {
	                  title: this.props.data.region.data.title[0].text,
	                  cardColor: determineColor(this.props.data.page.data.region.uid),
	                  to: "/" + json.lang + "/region/" + this.props.data.region.uid,
	                  type: json.lang === "en-us" ? "Region" : json.lang === "es-mx" ? "Regione" : "منطقة"
	                }),
	                this.props.data.institution && _react2.default.createElement(_components.TinyTile, {
	                  title: this.props.data.institution.data.title[0].text,
	                  cardColor: determineColor(this.props.data.institution.data.type),
	                  to: "/" + json.lang + "/institution/" + this.props.data.institution.uid,
	                  type: json.lang === "en-us" ? "Institution" : json.lang === "es-mx" ? "Institucione" : "لمؤسسة"
	                }),
	                this.props.data.institution2 && _react2.default.createElement(_components.TinyTile, {
	                  title: this.props.data.institution2.data.title[0].text,
	                  cardColor: determineColor(this.props.data.institution2.data.type),
	                  to: "/" + json.lang + "/institution/" + this.props.data.institution2.uid,
	                  type: json.lang === "en-us" ? "Institution" : json.lang === "es-mx" ? "Institucione" : "لمؤسسة"
	                }),
	                this.props.data.institution3 && _react2.default.createElement(_components.TinyTile, {
	                  title: this.props.data.institution3.data.title[0].text,
	                  cardColor: determineColor(this.props.data.institution3.data.type),
	                  to: "/" + json.lang + "/institution/" + this.props.data.institution3.uid,
	                  type: json.lang === "en-us" ? "Institution" : json.lang === "es-mx" ? "Institucione" : "لمؤسسة"
	                }),
	                this.props.data.project && _react2.default.createElement(_components.TinyTile, {
	                  title: this.props.data.project.data.title[0].text,
	                  cardColor: determineColor(this.props.data.page.data.region.uid),
	                  to: "/" + json.lang + "/project/" + this.props.data.project.uid,
	                  type: json.lang === "en-us" ? "Project" : json.lang === "es-mx" ? "Proyecto" : "مشروع"
	                }),
	                this.props.data.campaign && _react2.default.createElement(_components.TinyTile, {
	                  title: this.props.data.campaign.data.title[0].text,
	                  cardColor: determineColor(this.props.data.campaign.data.type),
	                  to: "/" + json.lang + "/campaign/" + this.props.data.campaign.uid,
	                  type: json.lang === "en-us" ? "Campaign" : json.lang === "es-mx" ? "Campaña" : "حملة"
	                }),
	                this.props.data.campaign2 && _react2.default.createElement(_components.TinyTile, {
	                  title: this.props.data.campaign2.data.title[0].text,
	                  cardColor: determineColor(this.props.data.campaign2.data.type),
	                  to: "/" + json.lang + "/campaign/" + this.props.data.campaign2.uid,
	                  type: json.lang === "en-us" ? "Campaign" : json.lang === "es-mx" ? "Campaña" : "حملة"
	                }),
	                this.props.data.campaign3 && _react2.default.createElement(_components.TinyTile, {
	                  title: this.props.data.campaign3.data.title[0].text,
	                  cardColor: determineColor(this.props.data.campaign3.data.type),
	                  to: "/" + json.lang + "/campaign/" + this.props.data.campaign3.uid,
	                  type: json.lang === "en-us" ? "Campaign" : json.lang === "es-mx" ? "Campaña" : "حملة"
	                }),
	                this.props.data.campaign4 && _react2.default.createElement(_components.TinyTile, {
	                  title: this.props.data.campaign4.data.title[0].text,
	                  cardColor: determineColor(this.props.data.campaign4.data.type),
	                  to: "/" + json.lang + "/campaign/" + this.props.data.campaign4.uid,
	                  type: json.lang === "en-us" ? "Campaign" : json.lang === "es-mx" ? "Campaña" : "حملة"
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _components.PageContent,
	            null,
	            json.data.body4[0] && _react2.default.createElement(_components.Accordion, {
	              title: json.lang === "en-us" ? "Overview" : json.lang === "es-mx" ? "Resumen" : "نظرة عامة",
	              id: "overview_tab",
	              data: json.data.body4,
	              startOpen: "true"
	            }),
	            json.data.body3[0] && _react2.default.createElement(_components.Accordion, {
	              title: json.lang === "en-us" ? "Concerns" : json.lang === "es-mx" ? "Puntos claves" : "اهتمامات",
	              id: "concerns_tab",
	              data: json.data.body3
	            }),
	            json.data.body2[0] && _react2.default.createElement(_components.Accordion, {
	              title: json.lang === "en-us" ? "Financing" : json.lang === "es-mx" ? "Financiación" : "تمويل",
	              id: "financing_tab",
	              data: json.data.body2
	            }),
	            json.data.tab_title_1[0] && _react2.default.createElement(_components.Accordion, {
	              title: json.data.tab_title_1[0].text,
	              id: json.data.tab_title_1[0].text.toLowerCase().replace(/ /g, "_") + "_tab",
	              data: json.data.body1
	            }),
	            json.data.tab_title_2[0] && _react2.default.createElement(_components.Accordion, {
	              title: json.data.tab_title_2[0].text,
	              id: json.data.tab_title_2[0].text.toLowerCase().replace(/ /g, "_") + "_tab",
	              data: json.data.body
	            }),
	            json.data.tab_title_3[0] && _react2.default.createElement(_components.Accordion, {
	              title: json.data.tab_title_3[0].text,
	              id: json.data.tab_title_3[0].text.toLowerCase().replace(/ /g, "_") + "_tab",
	              data: json.data.body_3
	            }),
	            json.data.tab_title_4[0] && _react2.default.createElement(_components.Accordion, {
	              title: json.data.tab_title_4[0].text,
	              id: json.data.tab_title_4[0].text.toLowerCase().replace(/ /g, "_") + "_tab",
	              data: json.data.body_4
	            })
	          )
	        ),
	        this.props.data.projectResources && _react2.default.createElement(
	          _components.PageSection,
	          { column: "true", borderTop: "true" },
	          _react2.default.createElement(_components.H2, {
	            children: json.lang === "en-us" ? "Related Resources" : json.lang === "es-mx" ? "Recursos Relacionados" : "موارد ذات الصلة",
	            mb: 5,
	            fontSize: [4, 5]
	          }),
	          _react2.default.createElement(
	            _components.CardLayout,
	            { w: 1 / 1 },
	            this.props.data.projectResources.edges.map(function (resource, index) {
	              return _react2.default.createElement(_components.ResourceCard, {
	                key: "resource" + index,
	                object: resource.node
	              });
	            })
	          )
	        ),
	        this.props.data.projectUpdates && _react2.default.createElement(
	          _components.PageSection,
	          { column: "true", borderTop: "true" },
	          _react2.default.createElement(_components.H2, {
	            children: json.lang === "en-us" ? "Related Updates" : json.lang === "es-mx" ? "Actualizaciones relacionadas" : "التحديثات ذات الصلة",
	            mb: 5,
	            fontSize: [4, 5]
	          }),
	          _react2.default.createElement(
	            _components.CardLayout,
	            { w: 1 / 1 },
	            this.props.data.projectUpdates.edges.sort(function (a, b) {
	              if ((0, _moment2.default)(a.node.data.publish_date).utc() < (0, _moment2.default)(b.node.data.publish_date).utc()) return 1;
	              if ((0, _moment2.default)(a.node.data.publish_date).utc() > (0, _moment2.default)(b.node.data.publish_date).utc()) return -1;
	              return 0;
	            }).slice(0, 4).map(function (update, index) {
	              return _react2.default.createElement(_components.UpdateCard, { key: "project" + index, object: update.node });
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return Project;
	}(_react2.default.Component);
	
	Project.contextTypes = {
	  setAltLanguages: _propTypes2.default.func
	};
	exports.default = Project;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-project-js-9ab04b0bd4f243769087.js